import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { migrateBigcommerceData, migrateBigcommerceDataForCustomers } from "src/api";
import Alert from "src/components/Alert";
import ServerPaginationTable from "src/components/ServerPaginationTable";
import SyncStatus from "src/components/SyncStatus";
import { loadConfig, loadCustomers, loadJob } from "src/redux/actions/bigcommerce";
import { addToast } from "src/redux/actions/toasts";

function Customers() {
  const customers = useSelector((state) => state.bigcommerce.customers);
  const dispatch = useDispatch();
  const job = useSelector((state) => state.bigcommerce.job);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [status, setStatus] = useState([]);
  const [sortBy, setSortBy] = useState();
  const [loading, setLoading] = useState(false);


  const data = useMemo(() => customers.data, [customers]);
  console.log('customer\'s data:', data);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "customerName",
      },
      {
        Header: "Email",
        accessor: "customerEmail",
      },
      {
        Header: "Sync Status",
        accessor: "syncStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.syncStatus}
              reason={row.original.reason}
              id={row.original.cartCustomerId}
            />
          );
        },
      },
      {
        Header: "Deskera Contact Code",
        accessor: "deskeraDocumentCode",
      },

    ],
    []
  );

  useEffect(() => {
    dispatch(loadCustomers());
    dispatch(loadConfig());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(loadJob());
  }, job);

  const config = useSelector((state) => state.bigcommerce.config)
  useEffect(() => {
    setLoading(false);
    if (data && data.totalPages) {
      setPageCount(data.totalPages);
    }
  }, [data]);

  const refreshData = ({ pageSize, pageIndex, status, sortBy }) => {
    setPageSize(pageSize);
    setPageIndex(pageIndex);
    setStatus(status);
    setSortBy(sortBy);
    setLoading(true);
    dispatch(loadCustomers(pageSize, pageIndex, status, sortBy));
  };

  async function handleSyncDataSubmit() {
    try {
      const resp = await migrateBigcommerceData();
    } catch (err) {
      dispatch(
        addToast({
          type: "danger",
          title: "Failure",
          message: err.message,
        })
      );
    }
  }

  return (
    <div className="p-4">
      <h3 className="mb-3">Customers</h3>
      {(!config?.data || !config?.data?.syncEnabled) && (
        <Alert type="warning">
          Your synced customers will appear here. Please complete{" "}
          <Link to="/app/bigcommerce" className="text-alert-warning">
            <u>Setup</u>
          </Link>{" "}
          before continuing.
        </Alert>
      )}
      <ServerPaginationTable
        data={data?.content ? data?.content : []}
        columns={columns}
        migrate={migrateBigcommerceDataForCustomers}
        cart="bigcommerce"
        refresh={refreshData}
        tab="Customers"
        pageCount={pageCount}
        loading={loading}
        rowId="id"
      />
    </div>
  );
}

export default Customers;
